// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__1AitK","Auth":"NavItem_Auth__24kjU","active":"NavItem_active__BPA9x","NotAuth":"NavItem_NotAuth__160Kn"};